import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Modal from 'shared/components/modal/modal';
import localizationConstants from 'shared/util/translation/constant';
import OddsRulesAndScoring from 'features/contestDetails/components/OddsRulesAndScoring';
import { BASKETBALL_ID } from 'features/createContest/constants/createContest';

interface IHowToPlay {
	handleClose: () => void;
}

const HowToPlay: FC<IHowToPlay> = ({ handleClose }) => {
	const { t } = useTranslation();

	return (
		<Modal
			title={t(localizationConstants.howToPlay)}
			closeModal={handleClose}
			isFooter={false}
			className='invite-friend-modal how-to-play-modal'
		>
			<OddsRulesAndScoring contestSportId={BASKETBALL_ID} />
		</Modal>
	);
};

export default HowToPlay;
